import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 8 10"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6.45.871a.625.625 0 0 0-.986-.717l-5 4.375a.626.626 0 0 0 .412 1.096h2.177L1.552 9.129a.625.625 0 0 0 .986.717l5-4.375a.626.626 0 0 0-.412-1.094H4.948z"
    }
  )
);
var SvgBoltFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BoltFilled_default = SvgBoltFilled;

export { BoltFilled_default as default };
